import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { AlertManager } from '../components/common/Alert';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const alertIdCounter = useRef(0);

  const showAlert = useCallback((message, type = 'info', error = null, duration = 5000) => {
    const id = `alert-${Date.now()}-${++alertIdCounter.current}`;
    setAlerts(prev => [...prev, { id, message, type, duration, error }]);
    return id;
  }, []);

  const dismissAlert = useCallback((id) => {
    setAlerts(prev => prev.filter(alert => alert.id !== id));
  }, []);

  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert, startLoading, stopLoading, isLoading }}>
      {children}
      <AlertManager alerts={alerts} onDismiss={dismissAlert} />
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
}; 